import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, withModifiers as _withModifiers, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "mt-16 my-2 block text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl" }, "Privacy policy", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "In this policy, you can read how we collect and use your information. It also describes how we use cookies.", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "How we collect and use information", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "We collect and use information in order to provide you the services of NsLookup.io. Unless stated otherwise, we do not process or store your IP address or any other personally identifiable information.", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Here are all the ways in which we collect and use your information:", -1)
const _hoisted_6 = { class: "list-disc" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Serving requests"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("In order to serve the web pages you request, we process — but do not store — your "),
  /*#__PURE__*/_createElementVNode("strong", null, "IP address"),
  /*#__PURE__*/_createTextVNode(".")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Diagnosing issues"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("When we encounter an issue while serving the web page that you have requested, we may store the "),
  /*#__PURE__*/_createElementVNode("strong", null, "date, time and query"),
  /*#__PURE__*/_createTextVNode(" of that request with our supplier "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://sentry.io/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Sentry"),
  /*#__PURE__*/_createTextVNode(". This data is not linked to you, and is retained for 90 days.")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Logging"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("In order to observe the function of NsLookup, we log some of "),
  /*#__PURE__*/_createElementVNode("strong", null, "the web pages you request"),
  /*#__PURE__*/_createTextVNode(". This data is not linked to you, and is handled and retained for 7 days by our logging partner "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.crowdstrike.com/products/observability/falcon-logscale/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "CrowdStrike"),
  /*#__PURE__*/_createTextVNode(".")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("strong", null, "Preventing abuse", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("strong", null, "IP address", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Analyzing web traffic"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("We processes "),
  /*#__PURE__*/_createElementVNode("strong", null, "the pages you request, as well as your IP address"),
  /*#__PURE__*/_createTextVNode(". Your IP address will not be stored.")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Serving ads"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Third party vendors and subcontractors, including "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://nitropay.com/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "NitroPay"),
  /*#__PURE__*/_createTextVNode(", will process personally identifiable information to show personalized advertisements. If you live in a region that requires consent, then this data will only be processed if you have given consent.")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("strong", null, "Contacting us", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("strong", null, "name and email address", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h2", null, "Cookies", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h2", null, "Safeguards", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, "NsLookup follows generally accepted industry standards and maintains reasonable safeguards to attempt to ensure the security, integrity and privacy of the information in NsLookup's possession.", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h2", null, "What choices do I have?", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", null, "Our partner NitroPay automatically detect which legislation applies to you. Depending on this, we'll show you links here to exercise your rights:", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode("GDPR: "),
    /*#__PURE__*/_createElementVNode("span", {
      id: "ncmp-consent-link",
      class: "text-[#4f46e5] font-medium [&>*]:underline"
    })
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode("CCPA: "),
    /*#__PURE__*/_createElementVNode("span", { "data-ccpa-link": "1" })
  ])
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h2", null, "Changes and questions", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", null, "We may revise this policy from time to time. The changes will not be retroactive, and the most current version of this policy will govern our relationship with you. By continuing to access or use NsLookup.io after those revisions become effective, you agree to the revised policy.", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("i", null, "Last updated: 2023-04-17")
], -1)

import MetaTags from '@/components/MetaTags.vue';
import ContentPage from '@/components/layout/ContentPage.vue';
import { askConsent, insertConsentLinks } from '@/common/consent';


export default /*#__PURE__*/_defineComponent({
  __name: 'PrivacyPolicy',
  setup(__props) {

insertConsentLinks();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _createVNode(MetaTags, {
        title: "Privacy policy — NsLookup.io",
        description: "The privacy policy for NsLookup. In this policy, you can read how we collect and use your information. It also describes how we use cookies.",
        url: "https://www.nslookup.io/privacy-policy/"
      })
    ])),
    _createVNode(ContentPage, null, {
      content: _withCtx(() => [
        _hoisted_1,
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("ul", _hoisted_6, [
          _hoisted_7,
          _hoisted_8,
          _hoisted_9,
          _createElementVNode("li", null, [
            _hoisted_10,
            _hoisted_11,
            _createTextVNode("We may count the number of queries originating from your "),
            _hoisted_12,
            _createTextVNode(" to enforce our "),
            _createVNode(_component_router_link, { to: "/terms-and-conditions/" }, {
              default: _withCtx(() => [
                _createTextVNode("terms and conditions")
              ]),
              _: 1
            }),
            _createTextVNode(". This data is retained for up to 1 hour.")
          ]),
          _hoisted_13,
          _hoisted_14,
          _createElementVNode("li", null, [
            _hoisted_15,
            _hoisted_16,
            _createTextVNode("When you "),
            _createVNode(_component_router_link, { to: "/contact-us/" }, {
              default: _withCtx(() => [
                _createTextVNode("contact us")
              ]),
              _: 1
            }),
            _createTextVNode(", you can provide your "),
            _hoisted_17,
            _createTextVNode(". If you do, they will be sent to us by email, in order for us to reply to you.")
          ])
        ]),
        _hoisted_18,
        _createElementVNode("p", null, [
          _createTextVNode("If you have given consent, then third party vendors, including NitroPay, use cookies to personalize advertisements and track usage. You can update your consent "),
          _createElementVNode("a", {
            href: "#",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(askConsent)()), ["prevent"]))
          }, "here"),
          _createTextVNode(".")
        ]),
        _hoisted_19,
        _hoisted_20,
        _hoisted_21,
        _hoisted_22,
        _hoisted_23,
        _hoisted_24,
        _hoisted_25,
        _createElementVNode("p", null, [
          _createTextVNode("If you have any questions or feedback regarding this privacy policy, you may "),
          _createVNode(_component_router_link, { to: "/contact-us/" }, {
            default: _withCtx(() => [
              _createTextVNode("contact us")
            ]),
            _: 1
          }),
          _createTextVNode(".")
        ]),
        _hoisted_26
      ]),
      _: 1
    })
  ], 64))
}
}

})